import { TetherInfo } from './tethers-types';
import { Environment } from '../environment/environment';
import { exposeLoginHandlerFunctions } from '../login/common';
import { appendUnityLoginIframe } from '../utils/landing';
import { Localization } from '../localization/localization';
import { ErrorSmallPopup } from '../popups/errorSmallPopup';
import { getUrlToLoginViaToken } from '../login/getUrlToLoginViaToken';

export function switchCurrentAccount(targetAccount: TetherInfo, targetSuid: string) {
    const loginUrl = getUrlToLoginViaToken(targetAccount.token, targetSuid);
    try {
        if (Environment.isSite()) {
            exposeLoginHandlerFunctions();
            appendUnityLoginIframe(loginUrl);
        } else {
            window.top.location.href = `${loginUrl}&state=switchAccount`;
        }
    } catch (error) {
        showSwitchErrorPopup(Localization._n('common_error'));
        window.Sentry.captureException(error);
    }
}

function showSwitchErrorPopup(message: string): void {
    const errorSmallPopup = ErrorSmallPopup.getInstance();
    errorSmallPopup.setMessage(message);
    errorSmallPopup.setButtonText(Localization._n('ecommpay.button_to_retry'));
    errorSmallPopup.show();
    errorSmallPopup.setCallback(() => {
        errorSmallPopup.hide();
    });
}
